import { render, staticRenderFns } from "./card-faq-item.vue?vue&type=template&id=3ee5d3e6&scoped=true&"
import script from "./card-faq-item.vue?vue&type=script&lang=js&"
export * from "./card-faq-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee5d3e6",
  null
  
)

export default component.exports